import {
  createPixelPortraitBlocks,
  createSingleSheetCanvas,
  drawBlock,
} from "./createPixelNumberCanvas";
import { getBlocksSheetData } from "./getBlocksSheetData";
import { downloadSheetsZip } from "./saveZipFile";
import { mmToPixels } from "./UTILS";

export const downloadSheetsAsZip = (inputCanvas, settings) => {
  const {
    palette,
    sheetData,
    fileName,
    fullPaletteCanvas,
    sourceSwatchSize,
    outputType,
  } = settings;

  const { blocks, blocksPerImageWidth, blocksPerImageHeight } =
    createPixelPortraitBlocks(inputCanvas, settings);

  const isStickerVersion =
    outputType === "stickersFinished" || outputType === "stickerCards";

  const fillinSheets = createPortraitSheetCanvases({
    blocks,
    blocksPerImageWidth,
    blocksPerImageHeight,
    ...settings,
    outputType: isStickerVersion ? "stickerCards" : "paintCards",
  });

  const finishedSheets = createPortraitSheetCanvases({
    blocks,
    blocksPerImageWidth,
    blocksPerImageHeight,
    ...settings,
    outputType: isStickerVersion ? "stickersFinished" : "paintFinished",
  });

  const paletteTiles = getSwatchCanvases(
    palette,
    fullPaletteCanvas,
    sourceSwatchSize,
    settings.outputType
  );

  downloadSheetsZip({
    fillinSheets,
    finishedSheets,
    paletteTiles,
    sheetData,
    fileName,
  });
};

const getSwatchCanvases = (
  palette,
  fullPaletteCanvas,
  sourceSwatchSize,
  outputType
) => {
  const { swatches, labels } = palette;
  let swatchesWithCount = swatches.map((swatch, index) => {
    return {
      ...swatch,
      index,
      label: labels[index],
    };
  });

  const swatchStuff = swatchesWithCount.map((swatch) => {
    const size = mmToPixels(12); // 12mm in pixels
    const outputCanvas = document.createElement("canvas");
    const ctx = outputCanvas.getContext("2d");
    outputCanvas.width = size;
    outputCanvas.height = size;

    const { customHue, hue, saturation, lightness, index, label } = swatch;

    const blockColour = `hsl(${
      customHue ? customHue : hue
    }, ${saturation}%, ${lightness}%)`;

    drawBlock({
      outputCtx: ctx,
      left: 0,
      top: 0,
      blockColour,
      blockSize: size,
      outputType,
      blockTypeIndex: index,
      label,
      fullPaletteCanvas,
      sourceSwatchSize,
    });

    return { canvas: outputCanvas, label: swatch.label };
  });

  return swatchStuff;
};

//
// CREATE DOWNLOAD CANVASES
//
const createPortraitSheetCanvases = ({
  blocks,
  blockSize,
  blocksPerImageWidth,
  blocksPerImageHeight,
  paperSize,
  palette,
  removeLightestColour,
  fullPaletteCanvas,
  sourceSwatchSize,
  outputType,
}) => {
  const blockSizeInMM = mmToPixels(blockSize);

  const sheetData = getBlocksSheetData(blocks, {
    blocksPerImageWidth,
    blocksPerImageHeight,
    paperSize,
    blockSize: blockSizeInMM,
    palette,
  });

  /**
   * For each sheet, create a canvas matching the sheet size
   */
  const sheetCanvases = sheetData.sheets.map((sheet, index) => {
    return createSingleSheetCanvas({
      blocks,
      blockSize,
      blocksPerImageWidth,
      blocksPerImageHeight,
      paperSize,
      palette,
      sheetIndex: index,
      outputType,
      sheetData,
      blockSizeInMM,
      removeLightestColour,
      fullPaletteCanvas,
      sourceSwatchSize,
    });
  });

  return sheetCanvases;
};
